import { reportError } from '@this/src/lib/bugsnag';
import React from 'react';

interface Props {
  encoding: string;
  onChange: (value: string) => void;
  style?: React.CSSProperties;
}

interface State {}

const defaultStyle: React.CSSProperties = {
  margin: 0
};

class EncodingSelector extends React.Component<Props, State> {
  componentDidMount() {
    this.props.onChange(navigator.platform.indexOf('Win') !== -1 ? 'sjis' : 'utf8');
  }

  render() {
    try {
      const { encoding, onChange, style } = this.props;
      return (
        <select value={encoding} onChange={e => onChange(e.target.value)} style={style || defaultStyle}>
          <option value="utf8">Macなど（文字コード：UTF8）</option>
          <option value="sjis">Windows（文字コード：SJIS）</option>
        </select>
      );
    } catch (e) {
      reportError(e);
      return null;
    }
  }
}

export default EncodingSelector;
